/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemLangGridItemViewModel } from "../types/ExamItemLangGridItemViewModel.ts";

export const examItemLangGridItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do item de questão traduzido.")),
  componentType: z
    .string()
    .describe(
      "Descrição textual do tipo de componente da questão (ex: SingleChoice, MultilineText). Opcional.",
    )
    .nullish(),
  weight: z.optional(
    z.number().int().describe("Peso da questão na composição da nota final."),
  ),
  label: z
    .string()
    .describe(
      "Enunciado da questão no idioma traduzido (pode conter HTML). Opcional.",
    )
    .nullish(),
  labelClean: z
    .string()
    .describe(
      "Enunciado da questão sem formatação HTML, utilizado para exibição simplificada. Opcional.",
    )
    .nullish(),
  disciplineName: z
    .string()
    .describe("Nome da disciplina associada à questão. Opcional.")
    .nullish(),
  personAuthorName: z
    .string()
    .describe("Nome do autor da questão. Opcional.")
    .nullish(),
  cultureInfo: z
    .string()
    .describe(
      "Código de cultura do idioma da tradução da questão (ex: pt-BR, en-US). Opcional.",
    )
    .nullish(),
  active: z.optional(
    z.boolean().describe("Indica se a tradução da questão está ativa."),
  ),
  cancelled: z.optional(
    z.boolean().describe("Indica se a tradução da questão foi cancelada."),
  ),
}) as unknown as ToZod<ExamItemLangGridItemViewModel>;
